import React, { useEffect, useState } from 'react'
import {
  CAlert,
  CAvatar,
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CImage,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'
import { useFormik } from 'formik'
import { GetParametrosInicioRequest, LoginRequest } from 'src/api/AuthRequest'
import { useRecoilState } from 'recoil'
import { authState } from 'src/recoil'
import Fondo from './img/Fondo.jpg'
import Qr from './img/qr.png'
import { GetUbicarParametrosRequest } from 'src/api/ParametrosRequest'
import { CONFIGS, updateApiUrl } from 'src/config/Configs'
import { updateApiInstance } from 'src/api/ApiConfig'
import { fechaComun } from 'src/helpers/fechas'

//no es en lecturas
const Login = () => {
  const [auth, setAuth] = useRecoilState(authState)
  const [showAlert, setShowAlert] = useState(false)
  const [tipoAlert, setTipoAlert] = useState('light')
  const [msgAlert, setMsgAlert] = useState('')
  const [loading, setLoading] = useState(false)

  // const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    onSubmit: (formData) => {
      setLoading(true)
      loginRequest(formData)
    },
  })

  const loginRequest = (data) => {
    LoginRequest(data)
      .then((res) => {
        if (res) {
          const backend = res.data.usuario.basedatos
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('refresh_token', res.data.refresh_token)
          updateApiUrl(backend)
          updateApiInstance()
          if (res.data.usuario.nro_emp === '0') {
            setMsgAlert('Bienvenido Super Usuario')
            setTipoAlert('success')
            setShowAlert(true)
            setTimeout(() => {
              localStorage.setItem('back', backend)
              setAuth({
                ...res.data.usuario,
                backend: backend,
              })
            }, 2000)
          } else {
            GetParametrosInicioRequest(res.data.usuario.cod_sucur)
              .then((resIniciales) => {
                // console.log("aqui:: ", resIniciales);
                if (resIniciales.data.vigencia) {
                  localStorage.setItem('aniofiscal', resIniciales.data.aniofiscal)
                  const fechaExpiracionBase = res.data.usuario.fecha
                  let fechaExpiracion = fechaComun(fechaExpiracionBase)
                  let fechaActual = new Date()
                  if (fechaActual.getTime() <= fechaExpiracion.getTime()) {
                    GetUbicarParametrosRequest(10)
                      .then((respuesta) => {
                        GetUbicarParametrosRequest(101)
                          .then((response) => {
                            setMsgAlert(res.response)
                            setTipoAlert('success')
                            setShowAlert(true)
                            setTimeout(() => {
                              localStorage.setItem('back', backend)
                              // console.log("las res iniciales: ", resIniciales);

                              setAuth({
                                ...res.data.usuario,
                                nombre_sucursal: resIniciales.data.nombre_sucursal,
                                fecha_ult_proc: resIniciales.data.fecha_ult_proc,
                                cod_activ: resIniciales.data.cod_activ,
                                paginacion: resIniciales.data.paginacion,
                                porcentaje_iva: respuesta.find(
                                  (parametro) => parametro.codigo === '1',
                                ).valor1,
                                cuentas: {
                                  cliente: response[0].ctacont,
                                  proveedor: response[0].ctacont1,
                                  inventario: response[0].ctacont2,
                                },
                                backend: backend,
                                empresa: {
                                  serie: resIniciales.data.serie,
                                  cod_empre: resIniciales.data.cod_empre,
                                },
                              })
                            }, 2000)
                          })
                          .catch()
                      })
                      .catch()
                  } else {
                    setMsgAlert('Usuario no Vigente')
                    setTipoAlert('error')
                    setTipoAlert('danger')
                    setLoading(false)
                    setShowAlert(true)
                    setTimeout(() => {
                      setShowAlert(false)
                    }, 3000)
                  }
                } else {
                  setMsgAlert('Empresa no Vigente')
                  setTipoAlert('error')
                  setTipoAlert('danger')
                  setLoading(false)
                  setShowAlert(true)
                  setTimeout(() => {
                    setShowAlert(false)
                  }, 3000)
                }
              })
              .catch((error) => {
                console.log('error en el GetParametrosInicioRequest: ', error)
              })
          }
        }
      })
      .catch((error) => {
        setLoading(false)
        setMsgAlert('Error: ' + error.response?.data?.response)
        setTipoAlert('danger')
        setShowAlert(true)
        setTimeout(() => {
          setShowAlert(false)
        }, 5000)
        console.log(error)
      })
  }

  const guardar = () => {
    setLoading(true)
    formik.handleSubmit()
  }

  const handleChange = (event) => {
    const { name, value } = event.target
    formik.setFieldValue(name, value.toUpperCase())
  }

  return (
    <div style={{ backgroundImage: `url(${Fondo})` }}>
      <div className="min-vh-100 d-flex flex-row align-items-center">
        <CContainer>
          <br />
          <br />
          <br />
          <CImage rounded thumbnail src={Qr} width={115} height={115} />
          {/* <CAvatar src={Qr} size="xl" shape="rounded-0" /> */}
          <CRow className="justify-content-center">
            <CCol md={4}>
              {showAlert && (
                <CAlert
                  color={tipoAlert}
                  dismissible
                  variant="solid"
                  onClose={() => setShowAlert(false)}
                >
                  {msgAlert}
                </CAlert>
              )}
              <CCardGroup>
                <CCard className="p-4">
                  <CCardBody>
                    <CForm onSubmit={formik.handleSubmit}>
                      <center>
                        <h1>Iniciar Sesión</h1>
                        <p className="text-medium-emphasis">Ingresar Contraseña</p>
                      </center>
                      <CInputGroup className="mb-3">
                        <CInputGroupText>
                          <CIcon icon={cilUser} />
                        </CInputGroupText>
                        <CFormInput
                          placeholder="Usuario"
                          autoComplete="correo"
                          name="email"
                          onChange={handleChange}
                          value={formik.values.email}
                          error={formik.errors.email}
                          required
                        />
                      </CInputGroup>
                      <CInputGroup className="mb-4">
                        <CInputGroupText>
                          <CIcon icon={cilLockLocked} />
                        </CInputGroupText>
                        <CFormInput
                          type="password"
                          placeholder="Contraseña"
                          autoComplete="current-password"
                          name="password"
                          onChange={formik.handleChange}
                          error={formik.errors.password}
                          required
                        />
                      </CInputGroup>
                      <CRow>
                        <center>
                          <CCol xs={8}>
                            <CButton
                              type="submit"
                              color="primary"
                              className="px-4"
                              disabled={loading}
                            >
                              {!loading ? 'Iniciar Sesión' : 'Cargando...'}
                            </CButton>
                          </CCol>
                        </center>
                      </CRow>
                    </CForm>
                  </CCardBody>
                </CCard>
                {/* <CCard className="text-white bg-primary py-5" style={{ width: '44%' }}>
                <CCardBody className="text-center">
                  <div>
                    <h2>Sign up</h2>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                      tempor incididunt ut labore et dolore magna aliqua.
                    </p>
                    <Link to="/register">
                      <CButton color="primary" className="mt-3" active tabIndex={-1}>
                        Register Now!
                      </CButton>
                    </Link>
                  </div>
                </CCardBody>
              </CCard> */}
              </CCardGroup>
            </CCol>
          </CRow>
        </CContainer>
      </div>
    </div>
  )
}

export default Login
